<template>
  <!-- Un mòbil fet amb HTML amb un exercici d'apren.ai corregit (substitueix la foto de la tauleta de SeleAI) -->
  <div class="aph" aria-hidden="true">
    <div class="aph-screen">
      <div class="aph-bar"><span class="aph-logo">a</span><b>apren.ai</b></div>
      <div class="aph-tag">{{ t.tag }}</div>
      <div class="aph-q">{{ t.q }}</div>
      <div class="aph-in">pH = 3</div>
      <div class="aph-ok">✓ {{ t.ok }}</div>
      <div class="aph-next">{{ t.next }}</div>
    </div>
  </div>
</template>

<script>
const TEXTS = {
  ca: { tag: 'PAU 2026 · Química', q: 'Calcula el pH d’una dissolució 10⁻³ M d’HCl.', ok: 'Correcte!', next: 'Següent exercici →' },
  es: { tag: 'PAU 2026 · Química', q: 'Calcula el pH de una disolución 10⁻³ M de HCl.', ok: '¡Correcto!', next: 'Siguiente ejercicio →' },
};
export default {
  name: 'AprenAiPhone',
  props: { lang: { type: String, default: 'ca' } },
  computed: { t() { return TEXTS[this.lang] || TEXTS.ca; } },
};
</script>

<style scoped>
.aph { width: 150px; flex: 0 0 auto; border-radius: 26px; background: #111; padding: 7px; box-shadow: 0 12px 28px rgba(0, 0, 0, .3); transform: rotate(-5deg);
  font-family: 'Rubik', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif; }
.aph-screen { background: #fff; border-radius: 20px; padding: 10px 9px 12px; display: flex; flex-direction: column; gap: 7px; min-height: 230px; text-align: left; }
.aph-bar { display: flex; align-items: center; gap: 5px; font-size: 11px; color: #111; }
.aph-logo { width: 18px; height: 18px; border-radius: 6px; background: #4ed452; color: #fff; font-weight: 800; display: flex; align-items: center; justify-content: center; font-size: 11px; }
.aph-tag { font-size: 9px; font-weight: 800; color: #1f9d2e; letter-spacing: .04em; }
.aph-q { font-family: Georgia, serif; font-size: 11px; line-height: 1.35; color: #1f2937; }
.aph-in { border: 2px solid #4ed452; border-radius: 8px; padding: 5px 7px; font-family: Georgia, serif; font-style: italic; font-size: 11px; background: #f3fdf2; }
.aph-ok { background: #e8f9e6; color: #13741d; font-weight: 700; border-radius: 8px; padding: 5px 7px; font-size: 11px; }
.aph-next { margin-top: auto; background: #0d3b10; color: #fff; border-radius: 8px; padding: 6px; font-size: 10px; font-weight: 700; text-align: center; }
</style>
